import React from 'react';
import { Outlet } from 'react-router-dom';

import Header from './Header';
import Footer from './Footer';

import "../../assets/css/style.module.css";

const Layout = () => {
    return (
        <>
            <Header />
            <div className='contents'>
                <Outlet />
            </div>
            <Footer />
        </>
    )
}

export default Layout;